import {
    closingBehavior,
    openLink,
    settingsButton,
} from "@telegram-apps/sdk-react";
import { Button } from "antd-mobile";
import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { getSafeAreaInsetBottom } from "~/components";
import { markAsNormalUser } from "~/hook/useAppNewUser";
import { Page } from "~/components/Page/Page";
import SafeAreaTop from "~/components/widget/SafeAreaTop/SafeAreaTop";

type WelcomeProps = {};

const Welcome: React.FC<WelcomeProps> = ({}) => {
    const { t } = useTranslation();

    const handleOpenUserAgreement = () => {
        openLink("https://telegram.org/tos/mini-apps", {
            tryBrowser: "chrome",
            tryInstantView: true,
        });
    };

    useEffect(() => {
        settingsButton.hide();
        closingBehavior.enableConfirmation();

        return () => {
            settingsButton.show();
            closingBehavior.disableConfirmation();
        };
    }, []);

    return (
        <Page bgThemeKey="bg_bottom">
            <SafeAreaTop />
            <div className="h-screen p-5 relative bg-bg_bottom">
                <div className="flex justify-center">
                    <svg
                        width="201"
                        height="200"
                        viewBox="0 0 201 200"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M16.4416 137.917L16.4415 142.32C16.4414 144.323 17.6851 146.116 19.5614 146.817L122.808 185.395C130.163 188.143 138.272 188.091 145.592 185.249L187.884 168.826C189.423 168.228 190.436 166.747 190.436 165.097V160.495L16.4416 137.917Z"
                            fill="#FF4702"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M141.19 186.601V158.387L34.0639 142.706L34.063 152.233L122.809 185.393C128.716 187.6 135.11 188.001 141.19 186.601Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M186.688 160.008L186.645 160.069V169.307L187.885 168.825C188.331 168.652 188.734 168.404 189.08 168.099V160.319L186.688 160.008Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M144.914 185.504V173.73L143.094 177.177V186.103C143.705 185.922 144.312 185.722 144.914 185.504Z"
                            fill="white"
                        />
                        <path
                            d="M64.3627 119.197L17.5267 136.39C16.0821 136.92 16.0788 138.962 17.5217 139.497L126.577 179.929C131.513 181.759 136.941 181.765 141.882 179.946L189.181 162.53C190.872 161.908 190.866 159.515 189.172 158.901L79.4919 119.165C74.6024 117.394 69.2446 117.405 64.3627 119.197Z"
                            fill="black"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M113.18 131.369C80.5041 132.077 51.8699 137.511 33.8701 145.556L126.575 179.926C131.511 181.756 136.939 181.763 141.879 179.944L189.179 162.528C190.869 161.906 190.863 159.512 189.169 158.899L113.18 131.369Z"
                            fill="#FF7400"
                        />
                        <path
                            d="M145.977 53.9022L145.81 55.7082C145.359 60.6055 134.546 63.0407 123.146 61.9891C111.746 60.9376 101.503 56.3868 102.013 51.6682L102.143 49.9783L145.977 53.9022Z"
                            fill="#FF7400"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M130.074 62.2045L131.098 56.5354L144.436 53.7661L145.977 53.9041L145.811 55.7101C145.453 59.592 138.585 61.9269 130.074 62.2045Z"
                            fill="black"
                        />
                        <path
                            d="M124.953 42.3215C137.068 43.439 146.533 48.2227 146.092 53.0003C145.652 57.7779 135.471 60.7495 123.356 59.632C111.241 58.5145 101.776 53.7351 102.217 48.9531C102.658 44.1711 112.838 41.2039 124.953 42.3215Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M139.488 45.9291C135.721 44.1739 130.627 42.8458 124.952 42.3222C112.837 41.2047 102.656 44.1719 102.215 48.9539C102.2 49.1209 102.197 49.288 102.205 49.4548C105.14 53.4677 112.557 56.7431 121.129 57.4069C132.091 58.2557 140.794 54.5078 140.567 49.0421C140.523 47.982 140.146 46.9348 139.488 45.9291Z"
                            fill="black"
                        />
                        <path
                            d="M137.2 32.1045L138.444 34.4038C141.816 40.6386 134.886 49.9876 124.815 55.4339C114.745 60.8802 102.945 61.3791 99.7559 55.3279L98.5718 53.1914L137.2 32.1045Z"
                            fill="#FF4702"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M130.691 51.5418L127.6 44.9L137.337 32.3546L138.445 34.4041C141.107 39.3265 137.348 46.1902 130.691 51.5418Z"
                            fill="#FF7400"
                        />
                        <path
                            d="M111.75 31.2063C122.451 25.4184 133.798 25.6624 137.088 31.7449C140.378 37.8273 134.371 47.4569 123.669 53.2447C112.968 59.0326 101.624 58.7943 98.3313 52.7062C95.0386 46.6181 101.048 36.9942 111.75 31.2063Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M126.469 27.0215C122.035 27.0767 116.82 28.465 111.751 31.2068C101.049 36.9947 95.0394 46.6186 98.3322 52.7067C98.3546 52.7482 98.3775 52.7895 98.4007 52.8305C103.862 55.5258 111.947 54.9866 119.074 50.9347C128.632 45.4999 132.846 35.7959 128.488 29.269C127.924 28.4251 127.245 27.6755 126.469 27.0215Z"
                            fill="black"
                        />
                        <path
                            d="M119.594 15.4983L122.274 17.5523C129.541 23.1217 128.178 35.3609 121.214 44.4477C114.25 53.5345 102.486 57.8954 95.519 52.4627L92.9995 50.5634L119.594 15.4983Z"
                            fill="#FF4702"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M122.041 43.3172L113.925 36.5753L119.178 16.0476L119.595 15.4971L122.275 17.551C129.245 22.8928 128.276 34.3703 122.041 43.3172Z"
                            fill="#FF7400"
                        />
                        <path
                            d="M93.0141 22.7945C100.415 13.1378 112.169 9.71808 119.259 15.1514C126.349 20.5848 126.102 32.8242 118.701 42.4809C111.301 52.1376 99.5525 55.5623 92.4564 50.124C85.3604 44.6856 85.6133 32.4512 93.0141 22.7945Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M108.42 12.8159C102.99 13.7379 97.2793 17.2315 93.0147 22.796C85.614 32.4527 85.361 44.6872 92.4571 50.1255C93.9671 51.2828 95.6878 52.0387 97.5324 52.4186C104.19 51.3689 110.81 46.3952 114.449 38.9388C119.588 28.4085 116.878 16.845 108.42 12.8159Z"
                            fill="black"
                        />
                        <path
                            d="M92.2148 9.73907L95.5898 9.83988C104.742 10.1132 110.787 20.8419 110.446 32.2853C110.104 43.7287 103.105 54.1417 94.2766 53.804L91.1223 53.7349L92.2148 9.73907Z"
                            fill="#FF4702"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M109.696 38.0778L99.1631 38.7923L92.1418 12.6789L92.2149 9.73755L95.5899 9.83836C104.742 10.1117 110.787 20.8404 110.446 32.2837C110.387 34.2627 110.128 36.2108 109.696 38.0778Z"
                            fill="white"
                        />
                        <path
                            d="M74.9077 31.191C75.271 19.03 82.8118 9.38626 91.74 9.65292C100.668 9.91959 107.62 19.9962 107.257 32.1572C106.894 44.3182 99.3609 53.9622 90.4245 53.6953C81.4881 53.4283 74.5445 43.352 74.9077 31.191Z"
                            fill="#FF7400"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M81.9591 13.7176C77.8816 17.6139 75.1253 23.9577 74.9092 31.1924C74.5459 43.3534 81.4896 53.4298 90.4259 53.6967C93.6292 53.7923 96.6522 52.6146 99.2292 50.5039C102.539 45.5408 104.012 38.826 102.783 31.9599C100.693 20.276 91.5282 12.3882 81.9591 13.7176Z"
                            fill="black"
                        />
                        <path
                            d="M98.2077 39.834L98.3912 36.1012C98.6852 26.1732 88.1694 18.9108 76.7259 18.572C65.2824 18.2331 54.4551 25.1673 54.2454 34.7492L54.119 38.1695L98.2077 39.834Z"
                            fill="white"
                        />
                        <path
                            d="M75.6473 56.4189C87.8084 56.7789 97.9014 49.2099 98.1882 39.5245C98.475 29.839 88.8475 21.6861 76.6864 21.326C64.5252 20.9659 54.4325 28.5261 54.1455 38.2204C53.8585 47.9148 63.4862 56.0588 75.6473 56.4189Z"
                            fill="#FF7400"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M93.2597 50.1296C89.1086 54.1491 82.7286 56.6278 75.6475 56.4182C63.4864 56.0581 53.8586 47.9141 54.1457 38.2197C54.1661 37.5299 54.2362 36.8508 54.3531 36.1847C58.4824 31.1731 65.4443 27.9269 73.159 28.0707C85.1419 28.2941 94.4061 36.6212 93.8498 46.6576C93.7839 47.8475 93.5828 49.0082 93.2597 50.1296Z"
                            fill="black"
                        />
                        <path
                            d="M88.6479 39.2553L85.9524 36.7751C78.6433 30.0498 66.4245 33.1344 58.6726 41.5591C50.9207 49.9839 49.068 62.7071 56.1706 69.142L58.6723 71.4779L88.6479 39.2553Z"
                            fill="#0D0E0E"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M52.0996 54.4161L59.7924 60.2128L81.1123 47.3553L88.6478 39.2548L85.9524 36.7747C78.6433 30.0494 66.4245 33.1339 58.6726 41.5587C55.2256 45.3049 52.9451 49.9009 52.0996 54.4161Z"
                            fill="white"
                        />
                        <path
                            d="M87.077 67.6506C95.315 58.6975 96.2071 46.1132 89.0766 39.5523C81.9462 32.9913 69.4795 34.9254 61.2415 43.8785C53.0035 52.8316 52.1048 65.4097 59.2419 71.9768C66.3789 78.5438 78.839 76.6036 87.077 67.6506Z"
                            fill="#FF7400"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M93.59 47.934C94.7554 54.2349 92.5192 61.7349 87.0765 67.6499C78.8385 76.603 66.3784 78.5431 59.2414 71.9761C58.9106 71.6717 58.5971 71.3545 58.3007 71.0252C58.5775 63.7891 63.2906 55.9402 71.1215 50.9431C78.7371 46.0834 87.3198 45.1907 93.59 47.934Z"
                            fill="black"
                        />
                        <path
                            d="M92.8417 45.9384L89.6091 45.3213C80.8435 43.6479 72.7743 52.8412 70.6275 64.0865C68.4807 75.3319 72.5958 86.8513 81.3614 88.5246L84.2446 89.1583L92.8417 45.9384Z"
                            fill="#0D0E0E"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M70.093 71.2374L82.4372 76.1426L88.7889 66.3109L92.8412 45.9389L89.6086 45.3218C80.843 43.6484 72.7738 52.8417 70.627 64.0871C70.1681 66.4909 69.9953 68.9073 70.093 71.2374Z"
                            fill="white"
                        />
                        <path
                            d="M104.669 70.6186C106.957 58.6334 101.872 47.5907 93.3202 45.9582C84.7688 44.3257 75.9731 52.7184 73.6851 64.7037C71.397 76.6889 76.4746 87.73 85.0339 89.364C93.5932 90.9981 102.381 82.6039 104.669 70.6186Z"
                            fill="#FF7400"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M101.928 52.2716C104.849 56.9424 106.031 63.6239 104.695 70.6269C102.406 82.6121 93.6127 91.0052 85.0462 89.3698C84.9484 89.3511 84.851 89.3312 84.7541 89.3101C82.7716 85.3374 81.6338 80.4296 81.7071 75.1323C81.888 62.0585 89.3854 51.56 98.4422 51.6853C99.6407 51.7018 100.807 51.9036 101.928 52.2716Z"
                            fill="black"
                        />
                        <path
                            d="M96.8461 50.8207L94.0615 51.9685C86.5109 55.0807 85.3928 67.2627 89.8769 78.1418C94.3611 89.021 103.739 96.8769 111.289 93.7647L114.074 92.6169L96.8461 50.8207Z"
                            fill="#0D0E0E"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M97.7212 89.7563C94.5675 86.8353 91.7815 82.7612 89.8776 78.1421C85.3934 67.263 86.5115 55.0809 94.0621 51.9687L96.8467 50.821L110.977 85.1028L97.7212 89.7563Z"
                            fill="white"
                        />
                        <path
                            d="M120.3 65.6417C115.521 54.0467 105.426 47.2095 97.7621 50.3684C90.0983 53.5273 87.7531 65.4923 92.5323 77.0872C97.3115 88.6821 107.4 95.5223 115.071 92.3605C122.741 89.1986 125.08 77.2366 120.3 65.6417Z"
                            fill="#FF7400"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M116.066 58.2103C117.711 60.3674 119.158 62.8682 120.301 65.6412C123.36 73.063 123.503 80.6353 121.198 85.9538C117.245 83.9738 112.702 80.4061 108.51 75.7242C100.145 66.3808 96.3463 56.1329 100.024 52.8404C102.874 50.2879 109.386 52.6612 116.066 58.2103Z"
                            fill="black"
                        />
                        <path
                            d="M139.426 83.2078L136.857 86.3851C135.435 88.1441 126.087 82.9404 115.977 74.7672C105.866 66.5941 98.8187 58.5442 100.241 56.7853L102.809 53.6079L139.426 83.2078Z"
                            fill="white"
                        />
                        <path
                            d="M124.044 80.7863C130.654 85.2876 135.829 87.6575 136.857 86.3854L139.483 83.1588L128.383 75.4185L124.044 80.7863Z"
                            fill="black"
                        />
                        <path
                            d="M123.686 65.2321C133.796 73.4052 140.863 81.4317 139.426 83.2093C137.989 84.987 128.659 79.7599 118.549 71.5868C108.438 63.4136 101.372 55.3871 102.809 53.6095C104.246 51.8318 113.575 57.0589 123.686 65.2321Z"
                            fill="#FF7400"
                        />
                        <path
                            d="M151.269 69.4862L151.75 67.3205C152.22 64.9216 142.473 60.6271 130.905 57.4353C119.337 54.2434 108.25 52.9888 107.403 55.1565L106.818 57.1552L151.269 69.4862Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M128.707 56.8504L126.647 62.656L151.267 69.4856L151.749 67.3199C152.218 64.921 142.471 60.6265 130.903 57.4347C130.168 57.232 129.435 57.0371 128.707 56.8504Z"
                            fill="#FF7400"
                        />
                        <path
                            d="M128.258 66.3614C140.551 69.7534 150.893 71.1448 151.355 69.4706C151.817 67.7964 142.225 63.6873 129.932 60.2953C117.638 56.9034 107.296 55.5104 106.834 57.1862C106.372 58.8619 115.964 62.9695 128.258 66.3614Z"
                            fill="black"
                        />
                        <path
                            d="M133.102 148.906C133.102 150.213 132.316 151.536 130.716 152.81C129.121 154.08 126.782 155.246 123.848 156.235C117.984 158.21 109.85 159.44 100.844 159.44C91.8368 159.44 83.7035 158.21 77.8393 156.235C74.9047 155.246 72.5658 154.08 70.9708 152.81C69.3707 151.536 68.585 150.213 68.585 148.906C68.585 147.599 69.3707 146.276 70.9708 145.002C72.5658 143.732 74.9047 142.566 77.8393 141.577C83.7035 139.602 91.8368 138.371 100.844 138.371C109.85 138.371 117.984 139.602 123.848 141.577C126.782 142.566 129.121 143.732 130.716 145.002C132.316 146.276 133.102 147.599 133.102 148.906Z"
                            stroke="white"
                        />
                        <path
                            d="M145.978 86.8884L139.593 118.069L133.208 149.25L138.89 121.502"
                            stroke="white"
                            stroke-linecap="round"
                        />
                        <path
                            d="M146.666 83.4847L147.454 79.6729"
                            stroke="white"
                            stroke-linecap="round"
                        />
                        <path
                            d="M55.9082 86.0376L68.6782 148.399L57.314 92.9028"
                            stroke="white"
                            stroke-linecap="round"
                        />
                        <path
                            d="M55.2202 82.6339L54.4325 78.822"
                            stroke="white"
                            stroke-linecap="round"
                        />
                        <path
                            d="M10.9671 73.2932L12.6402 64.4685C12.877 63.2193 13.6743 62.148 14.8028 61.5624L28.3781 82.2285L23.4445 94.9982C22.2939 95.1844 21.1503 94.6275 20.5874 93.6068L11.6113 77.3287C10.9335 76.0995 10.7057 74.6724 10.9671 73.2932Z"
                            fill="black"
                        />
                        <path
                            d="M46.8461 75.926L47.0217 75.3213C47.304 74.3491 47.2197 73.3072 46.7848 72.3931L44.3602 75.5423L46.8461 75.926Z"
                            fill="black"
                        />
                        <path
                            d="M22.6149 94.1253L25.514 84.5693C25.7513 83.787 26.3234 83.1503 27.0758 82.8309L45.9919 74.8005C46.517 74.5776 47.0702 75.0521 46.9299 75.605L44.5304 85.0605C44.3164 85.904 43.7169 86.597 42.913 86.9302L23.539 94.9625C23.001 95.1856 22.4458 94.6826 22.6149 94.1253Z"
                            fill="#FF7400"
                        />
                        <path
                            d="M13.9362 64.3944C13.3351 63.3115 13.8138 61.9467 14.9595 61.4764L34.125 53.6092C35.0898 53.2132 36.1985 53.5971 36.7118 54.5049L46.6321 72.052C47.2412 73.1292 46.7746 74.4966 45.6341 74.977L26.4137 83.0717C25.4402 83.4817 24.3142 83.0925 23.8016 82.169L13.9362 64.3944Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M23.8151 64.9033L26.6382 60.6863L31.7021 61.0177L30.6658 62.5713L27.4652 62.3665L25.6784 65.0284L23.8151 64.9033ZM31.2512 63.7604L31.2508 63.7604L31.2514 63.76L31.2512 63.7604ZM31.2512 63.7604L33.115 63.8857L33.9429 65.5662L32.1559 68.229L33.5691 71.0976L32.5331 72.6518L30.6694 72.5261L29.2562 69.6575L26.0559 69.4518L25.228 67.7713L26.2641 66.2171L29.4637 66.4232L31.2512 63.7604ZM34.5286 66.7549L35.3562 68.4348L34.3201 69.989L33.4922 68.3085L34.5286 66.7549ZM36.6776 68.5216L34.8911 71.1841L35.719 72.8645L38.5421 68.6475L36.301 64.0985L35.2647 65.6536L36.6776 68.5216ZM33.8514 62.785L31.9884 62.659L33.0242 61.1042L34.8881 61.2305L35.716 62.911L34.68 64.4652L33.8521 62.7847L33.8514 62.785ZM31.2621 73.7275L32.09 75.408L33.9536 75.5336L34.9896 73.9794L34.1617 72.299L33.1257 73.8532L31.2621 73.7275ZM29.3312 72.446L27.4692 72.3204L26.6413 70.6399L28.5049 70.7655L29.3328 72.446L29.3312 72.446ZM27.0148 65.1094L28.8781 65.2344L28.8784 65.235L29.9144 63.6808L28.0505 63.5545L27.0148 65.1094ZM24.942 66.1305L23.906 67.6847L24.7339 69.3652L22.8702 69.2395L22.0423 67.5591L23.0781 66.0042L24.942 66.1305ZM23.4561 70.4271L23.4553 70.427L23.4559 70.4267L23.4561 70.4271ZM25.3192 70.5533L23.4561 70.4271L25.697 74.9758L30.7597 75.3078L29.9318 73.6273L26.7321 73.4213L25.3192 70.5533Z"
                            fill="#FF7400"
                        />
                        <path
                            d="M67.3605 97.6029L73.5573 96.1716C74.4345 95.969 75.3562 96.1803 76.0575 96.7449L66.5325 111.435L56.8492 111.878C56.4005 111.185 56.4354 110.285 56.9366 109.629L64.9285 99.1709C65.532 98.3811 66.392 97.8266 67.3605 97.6029Z"
                            fill="black"
                        />
                        <path
                            d="M73.0226 96.2464L67.1745 97.6088C66.2282 97.8293 65.3896 98.3758 64.8058 99.1525L56.9727 109.573C56.5935 110.077 57.0348 110.784 57.6544 110.664L62.5374 109.724C63.871 109.467 65.0631 108.727 65.8853 107.646L73.6265 97.4515C74.1133 96.7878 73.51 96.1561 73.0226 96.2464Z"
                            fill="white"
                        />
                        <path
                            d="M75.8819 121.608L76.324 121.55C77.0346 121.455 77.6859 121.104 78.1544 120.561L75.422 119.888L75.8819 121.608Z"
                            fill="black"
                        />
                        <path
                            d="M57.5789 110.671L63.4588 109.501C64.0335 109.432 64.6093 109.621 65.0308 110.018L76.0697 120.46C76.3638 120.736 76.214 121.23 75.8157 121.297L69.0029 122.437C68.3952 122.539 67.7751 122.348 67.3299 121.922L56.8313 111.79C56.5942 111.539 56.6037 110.883 57.5789 110.671Z"
                            fill="#FF7400"
                        />
                        <path
                            d="M73.5428 97.4249C73.9747 96.8216 75.1209 96.4339 75.8125 97.1491L85.7562 106.628C86.288 107.141 86.3151 108.355 85.8796 108.939L77.7401 119.898C77.2233 120.591 76.2109 120.671 75.5744 120.069L65.3592 110.4C64.8159 109.886 64.7421 109.051 65.1879 108.462L73.5428 97.4249Z"
                            fill="#FF4702"
                        />
                        <circle
                            cx="170.093"
                            cy="95.1477"
                            r="16.5517"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M173.985 103.629C173.722 104.266 173.433 104.839 173.116 105.325L174.928 105.408C175.14 104.985 175.4 104.381 175.678 103.617C178.721 103.465 181.171 102.534 181.283 100.038C181.296 99.7351 181.341 98.498 180.269 98.2446C181.89 97.4701 183.513 92.7794 179.508 92.587L178.013 92.5054L177.892 92.5025C177.943 91.734 177.975 90.9424 177.986 90.1303L176.362 90.1268C176.34 90.7721 176.295 91.5614 176.223 92.4425C175.769 92.4203 175.311 92.3922 174.846 92.3564C174.927 91.588 174.99 90.8062 175.029 90.0163L173.205 89.7133C173.128 90.388 173.022 91.2236 172.888 92.1595C171.629 92.0016 170.312 91.7732 168.902 91.4399L168.371 93.6844L170.836 94.267C170.561 95.9243 169.858 99.5912 169.245 101L166.927 100.452L166.44 102.513C167.601 102.803 169.021 103.096 170.518 103.311C170.319 103.898 170.113 104.432 169.899 104.894C170.374 104.981 171.409 105.138 171.752 105.076C171.922 104.678 172.126 104.155 172.347 103.527C172.896 103.576 173.445 103.612 173.985 103.629ZM174.215 97.1235C174.215 97.1235 174.592 95.3903 174.647 94.7985C175.219 94.8747 175.851 94.8777 176.46 94.8806C178.034 94.8881 179.455 94.8948 179.291 96.1577C179.081 97.7711 176.844 97.4733 174.322 97.1378L174.215 97.1235ZM173.693 99.3202C173.638 99.912 173.154 101.599 173.154 101.599C173.299 101.615 173.443 101.631 173.585 101.647C176.221 101.942 178.319 102.176 178.521 100.624C178.667 99.5019 177.81 99.4892 176.251 99.4662C175.536 99.4557 174.673 99.4429 173.693 99.3202Z"
                            fill="#FF7400"
                        />
                        <path
                            d="M175.623 84.6267C161.98 89.7883 160.233 94.371 161.366 104.485C161.47 105.415 160.562 106.044 159.87 105.414C155.917 101.817 152.601 92.4688 158.914 85.6968C167.968 75.9842 179.986 82.4043 175.623 84.6267Z"
                            fill="#FF7400"
                        />
                        <circle
                            cx="169.596"
                            cy="32.1058"
                            r="13.7931"
                            fill="#FF7400"
                        />
                        <path
                            d="M177.794 22.5231C183.089 27.4543 179.124 31.42 174.887 33.823C172.755 35.0326 170.822 36.5738 169.324 38.5141C167.581 40.7704 165.437 42.9176 163.794 42.0738C153.54 36.8086 156.752 27.3556 160.066 23.2687C162.845 19.8416 171.498 16.6591 177.794 22.5231Z"
                            fill="white"
                        />
                        <path
                            d="M161.837 26.5434C164.177 25.0295 168.335 22.8808 170.122 21.9957C169.702 23.1562 169.26 28.6329 169.092 31.2261C167.592 31.4293 165.124 31.326 164.078 31.249C162.915 29.6002 162.1 27.4249 161.837 26.5434Z"
                            fill="#FF7400"
                        />
                        <path
                            d="M161.158 36.7404C160.806 34.7889 161.008 29.8758 161.154 27.6631C161.227 28.1894 162.726 31.0162 163.466 32.3638C163.93 32.5377 166.995 32.4505 168.469 32.3851C166.44 33.4136 162.75 35.7172 161.158 36.7404Z"
                            fill="#FF7400"
                        />
                        <circle
                            cx="31.8797"
                            cy="24.9201"
                            r="12.9499"
                            transform="rotate(-14.3159 31.8797 24.9201)"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M24.0728 19.8384C21.7562 23.1283 22.3693 27.8825 25.458 30.3406C25.5644 30.4797 25.6442 30.7147 25.6041 30.859L25.417 31.5324C25.3902 31.6285 25.3769 31.6766 25.3191 31.7104C25.2213 31.8886 25.017 31.9277 24.8661 31.7745C22.6205 30.1108 21.2861 27.4299 21.2354 24.4802C21.1732 19.4838 24.8317 15.3675 29.4502 15.2786C29.508 15.2448 29.5967 15.2733 29.6412 15.2876C29.8054 15.3926 29.8541 15.5654 29.8006 15.7578L29.6135 16.431C29.5467 16.6716 29.4178 16.7874 29.2135 16.8265C27.1928 16.9636 25.3001 18.0322 24.0728 19.8384ZM33.8808 16.9104C33.9786 16.7322 34.1829 16.6931 34.3338 16.8463C36.5349 18.4958 37.9137 21.1909 37.9511 24.1887C38.0133 29.1851 34.3548 33.3015 29.7363 33.3904C29.6785 33.4241 29.5898 33.3956 29.5453 33.3814C29.3811 33.2763 29.3324 33.1036 29.3859 32.9112L29.573 32.2379C29.6398 31.9974 29.7687 31.8816 29.973 31.8424C31.9937 31.7053 33.8864 30.6367 35.1137 28.8306C37.4303 25.5406 36.8172 20.7865 33.7285 18.3283C33.6221 18.1893 33.5423 17.9542 33.5958 17.7618L33.7829 17.0886C33.8096 16.9923 33.823 16.9443 33.8808 16.9104ZM29.9521 23.5599C31.75 24.3989 32.5219 25.2753 32.0541 26.9586C31.6933 28.2571 30.5247 28.982 29.126 28.795L28.8053 29.9492C28.694 30.1754 28.5207 30.2769 28.3431 30.2199L27.6772 30.0061C27.4686 29.8867 27.3755 29.6997 27.429 29.5074L27.7497 28.3532C26.3515 27.6423 25.8817 26.5486 26.0383 25.2894L26.0517 25.2413C26.1051 25.0488 26.2784 24.9473 26.4559 25.0043L27.2107 25.2466C27.3439 25.2894 27.4503 25.4284 27.4412 25.6349C27.3739 26.3991 27.6265 27.0564 28.7808 27.427C29.6243 27.6977 30.3929 27.3683 30.6068 26.5988C30.8206 25.8292 30.5012 25.4124 29.3249 24.7729C27.5271 23.9338 26.813 23.0237 27.254 21.4366C27.5881 20.2342 28.6989 19.5432 30.0842 19.7783L30.3916 18.6722C30.5029 18.4459 30.6762 18.3444 30.8538 18.4014L31.5197 18.6152C31.7283 18.7346 31.8214 18.9216 31.7679 19.114L31.4472 20.2682C32.4415 20.6922 33.0134 21.7662 32.897 22.8814L32.8837 22.9295C32.8302 23.1218 32.6569 23.2233 32.4793 23.1663L31.7691 22.9383C31.6359 22.8955 31.5294 22.7566 31.5251 22.5981C31.5036 21.8054 31.1398 21.3744 30.3407 21.1178C29.4528 20.8328 28.8885 21.123 28.7014 21.7964C28.5143 22.4698 28.6737 22.94 29.9521 23.5599Z"
                            fill="#FF7400"
                        />
                        <path
                            d="M35.082 37.4682C42.0119 35.6997 46.228 28.7731 44.4988 21.9972C38.165 23.6135 40.7079 32.2275 33.0136 34.191C25.3194 36.1545 20.5358 32.8393 19.4033 28.4014C21.1325 35.1773 28.1521 39.2367 35.082 37.4682Z"
                            fill="#FF7400"
                        />
                    </svg>
                </div>
                <h1 className="mt-3 text-text_1 text-h3 font-semibold text-center">
                    {t("welcome_page_title")}
                </h1>
                <p className="mt-1 text-text_2 text-body1 leading-6! text-center">
                    <Trans
                        i18nKey="welcome_page_desc"
                        components={{
                            brand: <span className="text-text_brand" />,
                        }}
                    />
                </p>
                <p className="text-text_3 text-body4 mt-3 text-center">
                    <Trans
                        i18nKey="welcome_page_aggrement"
                        components={{
                            aggrement: (
                                <span
                                    className="underline"
                                    onClick={handleOpenUserAgreement}
                                />
                            ),
                        }}
                    />
                </p>
                <div
                    className="bg-bg_bottom fixed left-0 right-0 py-3 px-4 w-full"
                    style={{
                        minHeight: "calc(54px + 1.5rem)",
                        bottom: getSafeAreaInsetBottom(),
                    }}
                >
                    <Button
                        block
                        style={
                            {
                                height: 54,
                                "--border-radius": "12px",
                                "--text-color": "var(--White)",
                                "--border-color": "transparent",
                                "--background-color": "var(--color_text_brand)",
                            } as React.CSSProperties
                        }
                        onClick={markAsNormalUser}
                    >
                        <span className="text-h6 font-semibold">
                            {t("welcome_page_btn")}
                        </span>
                    </Button>
                </div>
            </div>
        </Page>
    );
};

export default Welcome;
